import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Lock, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, setToken } from "@/lib/api";
import { BAR_NAME } from "@/lib/config";

export const GestoreLogin = ({ onSuccess }) => {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!pin.trim()) return;
    setBusy(true);
    try {
      const { token } = await api.pinLogin(pin.trim());
      setToken(token);
      toast.success("Accesso effettuato");
      onSuccess();
    } catch (err) {
      const msg = err?.response?.status === 429
        ? "Troppi tentativi. Riprova tra qualche minuto."
        : "PIN errato";
      toast.error(msg);
      setPin("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative z-[2] min-h-[calc(100vh-68px)] flex items-center justify-center px-5">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        data-testid="gestore-login"
        className="w-full max-w-sm rounded-2xl bg-black/50 backdrop-blur-xl ring-1 ring-white/10 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.6)]"
      >
        <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/15 ring-1 ring-primary/30 mx-auto mb-5">
          <Lock className="w-6 h-6 text-primary" />
        </div>
        <h1 className="font-serif text-3xl text-center mb-1">Area Gestore</h1>
        <p className="text-sm text-muted-foreground text-center mb-6">
          Inserisci il PIN per accedere al pannello di {BAR_NAME}.
        </p>
        <Input
          data-testid="pin-input"
          type="password"
          inputMode="numeric"
          autoFocus
          placeholder="• • • • • •"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          className="h-14 text-center text-2xl tracking-[0.5em] bg-zinc-900 border-zinc-800 focus-visible:ring-primary mb-4"
        />
        <Button
          data-testid="pin-submit"
          type="submit"
          disabled={busy || !pin.trim()}
          className="w-full h-12 rounded-full bg-primary hover:bg-amber-500 text-primary-foreground font-semibold transition-colors duration-300"
        >
          <LogIn className="w-4 h-4 mr-2" /> {busy ? "Verifica..." : "Entra"}
        </Button>
      </motion.form>
    </div>
  );
};
